<template>
    <div class="templete_box">
        <div class="templete">
            <el-tabs v-model="activeName" @tab-click="handleClick" class="wb_tabs turnover">
                <el-tab-pane label="总转化率" name="first" class="all_tabs" v-if="(module.indexOf(',customer-deal-show,')!=-1 && all_customer == '1')">
                    <div class="drop_box">   
                        <el-select v-model="allTime" @change="allSelectChange" placeholder="请选择" style="margin-right: 20px;">
                            <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>                    
                    </div>
                    <h4>总转化率</h4>
                    <div id="all_conversion_rate" style="width: 100%;height: 550px;margin-bottom: 100px;"></div>
                    <h4 class="mar_top">转化率对比</h4>
                    <div id="conversion_rate_compare" style="width: 100%;height: 550px;margin-bottom: 100px;">
                    </div>
                </el-tab-pane>
                <el-tab-pane label="个人转化率" name="second" class="person_tabs" v-if="module.indexOf(',customer-deal-show,')!=-1">   
                    <div class="drop_box">  
                        <el-select v-model="personTime" @change="personDateSelectChange" placeholder="请选择" style="margin-right: 20px;">
                            <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>  
                        <el-select v-model="salemanID" @change="personSalemanSelectChange" placeholder="请选择">
                            <el-option v-for="item in salemanList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>                                          
                    </div>                
                    <h4>个人转化率</h4>
                    <div id="person_conversion_rate" style="width: 100%;height: 550px;"></div>
                </el-tab-pane>
                <el-tab-pane label="毛利分析" name="third" class="profit_tabs" v-if="(module.indexOf(',customer-deal-show,')!=-1 && all_fee == '1')">
                    <div class="drop_box">   
                        <el-select v-model="profitTime" @change="profitSelectChange" placeholder="请选择" style="margin-right: 20px;">
                            <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>                    
                    </div>
                    <h1>毛利分析</h1>
                    <div id="profit_analysis" style="width: 100%;height: 550px;"></div>
                </el-tab-pane>
                <el-tab-pane label="回访记录汇总" name="fourth" class="history_tabs info customer_opt" v-if="module.indexOf(',customer-deal-show,')!=-1">
                     <div class="search_box clearfix mar_top mar_bot">  
                        <el-date-picker type="date" placeholder="回访开始时间" v-model="params.start_time" class="search_input search_inputBox" size="mini"></el-date-picker>
                        <el-date-picker type="date" placeholder="回访结束时间" v-model="params.end_time" class="search_input search_inputBox" size="mini"></el-date-picker>
                        <el-select v-model="params.salesman_id" placeholder="归属人" class="search_select search_inputBox">
                            <el-option v-for="item in belongList" :key="item.salesman_id" :label="item.name" :value="item.salesman_id"></el-option>
                        </el-select>
                        <el-input class="search_input search_inputBox" v-model="params.customer_name" placeholder="客户名称" size="mini"></el-input>
                        <div class="reset fcolor" @click="reset">重置</div>
                        <el-button class="publicBtn" @click="search">查询</el-button>
                    </div>
                    <!-- form -->
                    <!-- table -->
                    <el-table class="table" ref="multipleTable" :data="returnData" border stripe highlight-current-row size="mini" style="width: 100%;" height="100%">
                        <el-table-column prop="visit_time" label="回访日期" width="150"></el-table-column>
                        <el-table-column prop="customer_name" label="客户名称" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="salesman_name" label="归属人" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="type" label="回访方式" width="100" show-overflow-tooltip>
                            <template v-slot="scoped">
                                {{scoped.row.type == 1 ? "电话": scoped.row.type == 2 ? "网络" : "上门"}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="visit_name" label="回访对象" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="visit_content" label="回访内容" width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="remind" label="待办提醒" width="200" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="reminder_date" label="提醒日期" width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="result" label="待办结果" min-width="200" show-overflow-tooltip></el-table-column>
                    </el-table>
                    
                    <!-- 合计 -->
                    <div class="total">
                        <span>合计:</span><span>回访次数：{{total}}次</span><span>待办结果：{{resultTotal}}</span>
                    </div>
                    <!-- 分页 -->
                    <div class="pag">
                        <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div> 
</template>

<script>
import pagination from '../../components/pagination' 
export default {
    components: {
        pagination
    },
    data(){
        return {
            module: localStorage.dw_erp_power_code,
            activeName: 'first',
            salemanID: '',        // 登录用户ID,
            salemanList: [],

            allTime: '2',
            personTime: '2',
            profitTime: '2',

            timeList: [
                {
                    label: '按周',
                    value: '1'
                },
                {
                    label: '按月份',
                    value: '2'
                },
                {
                    label: '按季度',
                    value: '3'
                }    
            ],
            returnData: [],
            refresh: true,
            pages: {
                last_page: 0,
                total: 0,
                current_page: 1,
                per_page: 20
            },
            params: {
                per_page: 20,
                page: 1,
                start_time: '',
                end_time: '',
                salesman_id: '',
                customer_name: ''
            },
            belongList: [],
            total: 0,
            resultTotal: 0
        }
    },
    mounted(){
        this.getSalemenList() //销售人列表
        window.console.log(this.all_customer,this.all_fee)
        if(localStorage.dw_erp_power_code.indexOf(',customer-deal-show,')!=-1 && this.all_customer){
            this.activeName = 'first'
            this.getAllConversionData(2) //初始化总转化率数据
        }else{
            if(localStorage.dw_erp_power_code.indexOf(',customer-deal-show,')!=-1 && this.all_fee){
                this.activeName = 'third'
                this.getProfitData(2)             
            }else{
                this.activeName = 'second'
                this.getPersonConversionData(2, localStorage.getItem('dw_erp_user_id'))      
            }
        }
        this.getReturnTotal()
        this.getBelongList()
    },
    methods:{       
        handleClick(){
            if(this.activeName == 'first'){       
                this.getAllConversionData(this.allTime)
            }
            if(this.activeName == 'second'){       
                this.getPersonConversionData(this.personTime, this.salemanID)        
            }
            if(this.activeName == 'third'){          
                this.getProfitData(+this.profitTime)
            }
        },
        getSalemenList(){
            this.postFunc("erp/user.select", {}, res=>{
                this.salemanList = res.data.data
                this.salemanID = +localStorage.getItem('dw_erp_user_id')           
            })
        },
        //初始化总转化率
        initAllCharts(time, dataline, seriesData){
            let top_echart =  window.echarts.init(document.getElementById('all_conversion_rate'));
            var option = {
                title: {
                    text: '转化率=成交次数/联系次数',
                    textStyle: {
                        fontSize: 12,
                        color: '#aaa'
                    },
                    x: '80px',
                    y: '10px'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: function (point, params, dom, rect, size) {
                        // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                        // 提示框位置
                        var x = 0 // x坐标位置
                        var y = 0 // y坐标位置                       
                        // 当前鼠标位置
                        var pointX = point[0]
                        var pointY = point[1]                        
                        // 外层div大小
                        // var viewWidth = size.viewSize[0]
                        // var viewHeight = size.viewSize[1]                     
                        // 提示框大小
                        var boxWidth = size.contentSize[0]
                        var boxHeight = size.contentSize[1]                      
                        // boxWidth > pointX 说明鼠标左边放不下提示框
                        if (boxWidth > pointX) {
                            x = 5;
                        } else { // 左边放的下
                            x = pointX - boxWidth
                        }                       
                        // boxHeight > pointY 说明鼠标上边放不下提示框
                        if (boxHeight > pointY) {
                            y = 5;
                        } else { // 上边放得下
                            y = pointY - boxHeight
                        }                       
                        return [x, y]
                    },
                    formatter: function (params, ticket, callback) {
                        var len = +params.length
                        len = Math.floor(len/2)                    
                        var res =params[0].name;
                        var contactTotal = 0
                        var dealTotal = 0
                         
                        for (var i = 0, l = params.length/2 - 1; i < l; i++) {                                                                         
                            contactTotal += +params[i].value
                            dealTotal += +params[len].value
                            res += '<br/><span style="font-size: 12px; display: inline-block; width: 80px; text-align: right;margin-right: 10px;">' + params[i].seriesName + ' :</span>' +'<span style="font-size: 12px; display: inline-block; width: 80px;text-align: left;">' + '联系' + params[i].value + '次</span>' +'<span style="font-size: 12px; display: inline-block; width: 90px;text-align: left;">' + '成交' + params[len].value + '次</span>'
                            len += 1 
                        }
                        if(contactTotal == 0){
                              res += '<p style="text-align: left;border-top: 1px solid #fff;margin-top: 5px;padding-top: 3px;"><span style="font-size: 12px; display: inline-block; width: 80px; text-align: right;margin-right: 10px;">' + params[params.length-1].seriesName + ' :</span><span style="font-size: 12px; display: inline-block; width: 80px;text-align: left;">' + params[params.length-1].value + '%</span></p>'
                        }else{
                            res += '<p style="text-align: left;border-top: 1px solid #fff;margin-top: 5px;padding-top: 3px;"><span style="font-size: 12px; display: inline-block; width: 80px; text-align: right;margin-right: 10px;">' + params[params.length-1].seriesName + ' :</span><span style="font-size: 12px; display: inline-block; width: 80px;text-align: left;">' + dealTotal + '/'+ contactTotal + '=' + params[params.length-1].value + '%</span></p>'
                        }                    
                        setTimeout(function () {
                            // 仅为了模拟异步回调
                            callback(ticket, res);
                        }, 100)
                        return 'loading...';
                    }
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    itemWidth: 6,
                    itemHeight: 6,
                    itemGap: 20,
                    padding:[0,100,0,100],
                    data: dataline, //legend 参数
                    textStyle: {
                        fontSize: 12,
                        color: '#888'
                    }
                },               
                grid: {
                    left: '6%',
                    right: '8%',
                    bottom: '12%',
                    containLabel: true
                },
                xAxis: [
                    {type: 'category',data: time} //time x
                ],
                yAxis: [
                    {type: 'value'},
                    {type: 'value'}
                ],
                series: seriesData  //series 参数
            }
            top_echart.setOption(option, true);
             setTimeout(function(){
				top_echart.resize();
			}, 0);
            
        },
        initCompareCharts(time, comparedataline, conversionRate){
            let down_echart =  window.echarts.init(document.getElementById('conversion_rate_compare'));
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: function (point, params, dom, rect, size) {
                        var x = 0; 
                        var y = 0; 
                    
                        var pointX = point[0];
                        var pointY = point[1];
                    
                        var boxWidth = size.contentSize[0];
                        var boxHeight = size.contentSize[1];
                        
                      
                        if (boxWidth > pointX) {
                            x = 5;
                        } else { 
                            x = pointX - boxWidth;
                        }
                        
                        if (boxHeight > pointY) {
                            y = 5;
                        } else { 
                            y = pointY - boxHeight;
                        }
                        return [x, y];
                    },
                    formatter: function (params, ticket, callback) {
                        var res =params[0].name;
                        for (var i = 0, l = params.length; i < l; i++) {
                            res += '<br/><span style="font-size: 12px; display: inline-block; width: 70px; text-align: right;margin-right: 10px;">' + params[i].seriesName + ' :</span>' +'<span style="font-size: 12px; display: inline-block; width: 50px;text-align: left;">' +  (params[i].value *100).toFixed(2) + '%</span>'
                        }
                        res += '<br/><p style="margin-top: 10px;"></p>'
                        setTimeout(function () {
                            // 仅为了模拟异步回调
                            callback(ticket, res);
                        }, 100)
                        return 'loading...';
                    }
                 },
                grid: {
                    left: '6%',
                    right: '10%',
                    bottom: '12%',
                    containLabel: true
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    itemWidth: 12,
                    itemHeight: 6,
                    itemGap: 20,
                    padding:[0,100,0,100],
                    data: comparedataline,// comparedataline 参数
                    textStyle: {
                        fontSize: 12,
                        color: '#888'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: time // time 参数
                },
                yAxis: {
                    type: 'value'
                },
                series: conversionRate
            }
            down_echart.setOption(option, true);
             setTimeout(function(){
				down_echart.resize();
			}, 0);
        },
        initPersonCharts(time, contactList, dealList, conversionRate){
            let top_echart =  window.echarts.init(document.getElementById('person_conversion_rate'));
            let option = {
                 title: {
                    text: '转化率=成交次数/联系次数',
                    textStyle: {
                        fontSize: 12,
                        color: '#aaa'
                    },
                    x: '75px',
                    y: '10px'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params, ticket, callback) {
                        let res = params[0].name;
                        res += '<br/><span style="font-size: 12px; display: inline-block; width: 50px; text-align: right;margin-right: 10px;">联系:</span>'
                            +'<span style="font-size: 12px; display: inline-block; width: 60px;text-align: left;">' + params[0].value + '次</span><br/>'
                            +'<span style="font-size: 12px; display: inline-block; width: 50px;text-align: right;margin-right: 10px;">成交:</span>' 
                            +'<span style="font-size: 12px; display: inline-block; width: 60px;text-align: left;">' + params[1].value + '次</span><br/>'
                            +'<span style="font-size: 12px; display: inline-block; width: 50px;text-align: right;margin-right: 10px;">成交率:</span>' 
                            +'<span style="font-size: 12px; display: inline-block; width: 60px;text-align: left;">' + (params[2].value *100).toFixed(2) + '%</span>'                       
                        setTimeout(function () {
                            // 仅为了模拟异步回调
                            callback(ticket, res);
                        }, 100)
                        return 'loading...';
                    }               
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    itemWidth: 6,
                    itemHeight: 6,
                    itemGap: 20,
                    padding:[0,100,0,100],
                    data: [ '联系次数', '成交次数', '转化率'],
                    textStyle: {
                        fontSize: 12,
                        color: '#888'
                    },
                    selectedMode:false
                },              
                grid: {
                    left: '6%',
                    right: '8%',
                    bottom: '12%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: time //time 参数
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    },
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '联系次数',
                        type: 'bar',
                        barWidth: 25,
                        stack: '联系次数',
                        data: contactList //contactList 参数
                    },          
                    {
                        name: '成交次数',
                        type: 'bar',
                        barWidth: 25,
                        stack: '成交次数',
                        data: dealList //dealList 参数
                    },
                    {
                        name: '转化率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: conversionRate //conversionRate 参数
                    }               
                ]
            }
            top_echart.setOption(option, true);
            setTimeout(function(){
				top_echart.resize();
			}, 0);
        },
        initProfitCharts(time, dataline, amount){
            let down_echart =  window.echarts.init(document.getElementById('profit_analysis'));
            let option = {
                   tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    position: function (point, params, dom, rect, size) {            
                        var x = 0; 
                        var y = 0; 
                        
                        var pointX = point[0];
                        var pointY = point[1];
                        
                        var boxWidth = size.contentSize[0];
                        var boxHeight = size.contentSize[1];
                        
                        if (boxWidth > pointX) {
                            x = 5;
                        } else { // 左边放的下
                            x = pointX - boxWidth;
                        }
                       
                        if (boxHeight > pointY) {
                            y = 5;
                        } else { // 上边放得下
                            y = pointY - boxHeight;
                        }                       
                        return [x, y];
                    },
                    formatter: function (params, ticket, callback) {
                        let total = 0
                        for(var j = 0; j<params.length; j++){
                            total += params[j].value
                        }
                        
                        let res =params[0].name;
                        for (var i = 0, l = params.length; i < l; i++) {
                            var percent = total == 0 ? 0 : params[i].value/total*100
                            res += '<br/><span style="font-size: 12px; display: inline-block; width: 80px; text-align: right;margin-right: 10px;">' + params[i].seriesName + ' :</span>'
                                +'<span style="font-size: 12px; display: inline-block; width: 90px;text-align: left;">￥' + params[i].value + '</span>'
                                +'<span style="font-size: 12px; display: inline-block; width: 80px;text-align: left;">' + percent.toFixed(2) + '%</span>'
                        }
                        res += '<p style="text-align: left;border-top: 1px solid #fff;margin-top: 5px;padding-top: 3px;"><span style="font-size: 12px; display: inline-block; width: 80px; text-align: right;margin-right: 10px;">合计:</span><span style="font-size: 12px; display: inline-block; width: 80px;text-align: left;">￥'+total.toFixed(2)+'</span></p>'
                        setTimeout(function () {
                            // 仅为了模拟异步回调
                            callback(ticket, res);
                        }, 100)
                        return 'loading...';
                    }
                },
                legend: {
                    x: 'center',
                    y: 'bottom',
                    itemWidth: 6,
                    itemHeight: 6,
                    itemGap: 20,
                    padding:[0,100,0,100],
                    data: dataline, //dataline 参数
                    textStyle: {
                        fontSize: 12,
                        color: '#888'
                    }
                },
                
                grid: {
                    left: '6%',
                    right: '8%',
                    bottom: '12%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: time //time 参数
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: amount
            }
            down_echart.setOption(option, true); 
            setTimeout(function(){
				down_echart.resize();
			}, 0);   
        },
        //总转化率数据
        getAllConversionData(type){
            this.postFunc("erp/customer.deal.analysis", {type: type}, res=>{
                let time = res.data.data.time
                let dataline = res.data.data.dataline            
                let comparedataline = res.data.data.dataline            
                let visitData = res.data.data.visit
                let sellData = res.data.data.sell
                let conversionRate = res.data.data.cvr

                dataline = dataline.concat(dataline)
                dataline.push("转化率")

                visitData.forEach(item=>{
                    item.type = 'bar'
                    item.stack = '联系次数'
                })
                sellData.forEach(item=>{
                    item.type = 'bar'
                    item.stack = '成交次数'
                })

                let visitTimesList = []
                let sellTimesList = []
                let curVisitTotal = 0         
                let curSellTotal = 0         
                let len = +visitData.length
                let len_ = +sellData.length 
                for(var i = 0; i < 12; i++){
                    curVisitTotal = 0
                    for(var j = 0; j < len; j++){
                        curVisitTotal += visitData[j].data[i]
                    }                  
                    visitTimesList.push(curVisitTotal)
                }
                for(var m = 0; m < 12; m++){
                    curSellTotal = 0
                    for(var n = 0; n < len_; n++){
                        curSellTotal += sellData[n].data[m]
                    }                  
                    sellTimesList.push(curSellTotal)
                }
 
                let allConversionRteList = []
                for(var o = 0; o < 12; o++){
                    if(visitTimesList[o] != 0){
                        if(sellTimesList[o] != 0){
                            let result = sellTimesList[o]/visitTimesList[o]
                            result = result*100
                            allConversionRteList.push(result.toFixed(2))
                        }else{
                            allConversionRteList.push(0)
                        }
                    }else{
                        allConversionRteList.push(0)
                    }
                }
      
                let seriesData = visitData.concat(sellData)
                seriesData.push(
                    {
                        name: '转化率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: allConversionRteList
                    }
                )
                this.initAllCharts(time, dataline, seriesData) //初始化总转化率数据

                conversionRate.forEach(item=>{
                    item.type = 'line'
                })
                this.initCompareCharts(time, comparedataline, conversionRate) //初始化转化率对比数据
            })
        },
        //总转化率change事件回调
        allSelectChange(){          
            this.getAllConversionData(this.allTime)    
        },
        //个人转化率数据
        getPersonConversionData(type, saleman_id){
            this.postFunc("erp/customer.person.analysis", {type: type, salesman_id: saleman_id}, res=>{
                let time = res.data.data.time
                let contactList = res.data.data.visit
                let dealList = res.data.data.sell
                let conversionRate = res.data.data.cvr
                this.initPersonCharts(time, contactList, dealList, conversionRate)
            })
        },
        //毛利数据
        getProfitData(type){
            this.postFunc("erp/customer.deal.maoli", {type: type}, res=>{
                let dataline = res.data.data.dataline
                let time = res.data.data.time
                let amount = res.data.data.amount
                amount.forEach(item=>{
                    item.type = 'bar'
                    item.stack = '毛利润'
                })
                this.initProfitCharts(time, dataline, amount)
            })
        },
        //个人转化率日期change事件回调
        personDateSelectChange(){       
            this.getPersonConversionData(this.personTime, this.salemanID)    
        },
        //个人转化率销售人change事件回调
        personSalemanSelectChange(){         
            this.getPersonConversionData(this.personTime, this.salemanID)    
        },
        //毛利分析日期change事件回调
        profitSelectChange(){
            this.getProfitData(this.profitTime)
        },
        //回访记录汇总
        getReturnTotal(){
            let obj = JSON.parse(JSON.stringify(this.params))
            obj.start_time = obj.start_time ? Date.parse(new Date(obj.start_time))/1000 : ''
            obj.end_time = obj.start_time ? (Date.parse(new Date(obj.end_time))/1000 + 86399) : ''
            this.postFunc("erp/customer.visit.total", obj, res=>{
                let resData = res.data.data.data
                resData.forEach(item=>{
                    item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
                    item.reminder_date = item.reminder_date ? this.formatTimeSecond(item.reminder_date*1000) : ''     
                })
                this.returnData = resData
                let obj = {}
                obj.total = Number(res.data.data.total)
                obj.per_page = Number(res.data.data.per_page)
                obj.current_page = Number(res.data.data.current_page)
                obj.last_page = Number(res.data.data.last_page)
                this.pages = obj
                this.total = res.data.data.total
                this.resultTotal = res.data.data.total_remind
            })
        },
        reset(){
            this.params = {
                per_page: 20,
                page: 1,
                start_time: '',
                end_time: '',
                salesman_id: '',
                customer_name: '' 
            }
            this.getReturnTotal()
        },
        search(){
            this.params.page = 1
            this.getReturnTotal()
        },
        getPage(obj){
            this.params.page = obj.currentpage;
            this.params.per_page = obj.pagesize;
        },
        getBelongList(){
            this.postFunc("erp/customer.visit.select", {}, res=>{
                this.belongList = res.data.data       
            })
        }
    },
    watch: {
        "params.page":function(){
            this.getReturnTotal()
        },
        "params.per_page":function(){
            this.getReturnTotal()
        },
        pages(){
            //强制刷新组件
            this.refresh= false
            this.$nextTick(()=>{
                this.refresh = true
            })
        }   
    },
    computed:{
        all_customer:()=>{
            return localStorage.dw_erp_all_customer == '1'
        },
        all_fee:()=>{
            return localStorage.dw_erp_all_fee == '1'
        },
    }
}
</script>

<style lang="scss" scoped>
.person_tabs, .all_tabs, .profit_tabs{
    position: relative;
    .drop_box{
        position: absolute;
        right: 15%;
        top: 33px;
        z-index: 100;   
    } 
}
.history_tabs{
    display: flex;
    flex-direction: column;
    height: 100%;
    .search_box{
        margin-bottom: 10px;
    }
    .table{
        flex: 1;
    }
    .pag{
        width: 100%;
        text-align: center;
       
    }
    .total{
        display: flex;
        margin-top: 10px;
        background-color: #f2f2f2;
        padding: 10px;
        font-size: 14px;
        padding-left: 40px;
        span{
            margin-right: 20px;
        }
    }
}



.person_tabs /deep/ .el-input__inner, .all_tabs /deep/ .el-input__inner, .profit_tabs /deep/ .el-input__inner{
    width: 80px;
    height: 24px;
    line-height: 24px;
    border-radius: 0;
    font-size: 12px;
    padding: 0 0 0 10px;
}
.person_tabs /deep/ .el-select__caret{
    right: -5px;
}
.person_tabs /deep/ .el-select__caret, .all_tabs /deep/ .el-select__caret, .profit_tabs /deep/ .el-select__caret{
    position: relative;
    height: 24px;
    line-height: 24px;
}
.person_tabs /deep/ .el-select-dropdown__item, .all_tabs /deep/ .el-select-dropdown__item, .profit_tabs /deep/ .el-select-dropdown__item{
    font-size: 12px;
}

.turnover /deep/ .el-table th.gutter {display: table-cell !important;}
.turnover /deep/ .el-table th.gutter{display: block !important;width: 28px !important;}
.turnover /deep/ .el-tablecolgroup.gutter{display: block !important;width: 28px !important;}  
.turnover /deep/ .el-table--border, .turnover /deep/ .el-table--group {border: 1px solid #fff;}
.turnover /deep/  .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;border-top: 1px solid #ddd;position: relative;top: -1px;}
</style>